import React from 'react';

import QuickLinks from './quick-links';
import QuickNavigation from './quick-nav';

const Component = (props) => {
    const { external, links, navs } = props;

    return (
        <div className="row quicks">
            <div className="col-sm-12">
                <QuickLinks external={external} links={links} />
            </div>
            <div className="col-sm-12">
                <QuickNavigation navs={navs} />
            </div>
        </div>
    );
};

export default Component;
